import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";
import type { LawyerDTO, RepresentativeProfile } from "./types/lawFirm";

export interface UpdateLawyerRequest {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  role?: string;
  title?: string;
  address?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  phone?: string;
  /** Replaces the whole list; there are no arrayUnion/arrayRemove semantics. */
  betaFeatures?: string[];
  organizeInstruction?: string;
  documentTitleStyle?: string;
  /** "" = default, "inherit" = the case agent turn's model, else a catalog id. */
  subagentModel?: string;
  subagentThinking?: boolean;
  /** Replaces the whole section; null clears it. */
  representative_profile?: RepresentativeProfile | null;
}

export const LawyerAPI = {
  async get(lawyerId: string): Promise<LawyerDTO> {
    try {
      const response = await axiosInstance.get(`/lawyers/${lawyerId}`);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async update(
    lawyerId: string,
    data: UpdateLawyerRequest
  ): Promise<LawyerDTO> {
    try {
      const response = await axiosInstance.put(`/lawyers/${lawyerId}`, data);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async disable(lawyerId: string): Promise<LawyerDTO> {
    try {
      const response = await axiosInstance.post(`/lawyers/${lawyerId}/disable`);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async enable(lawyerId: string): Promise<LawyerDTO> {
    try {
      const response = await axiosInstance.post(`/lawyers/${lawyerId}/enable`);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async uploadAvatar(lawyerId: string, file: File): Promise<{ success: true }> {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        `/lawyers/${lawyerId}/avatar`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async acceptTerms(lawyerId: string): Promise<{ success: true }> {
    try {
      const response = await axiosInstance.post(
        `/lawyers/${lawyerId}/accept-terms`
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
